import React from 'react';
import Modal from 'react-modal';
import "./VideoModal.css"

// Utility function to determine if URL is a YouTube video
const isYouTubeUrl = (url) => {
  return url.length===11 && !url.includes('.mp4');
};

const VideoModal = ({ isOpen, closeModal, videoId }) => {

  // Determine if videoId is a YouTube ID or an S3 URL
  const isYouTubeVideo = isYouTubeUrl(videoId);

  const videoUrl = process.env.REACT_APP_ANGELARMY_TEMPLATE + "BannerVideoThumbnails/VideoThumbnails/";

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Video Modal"
      overlayClassName="ReactModal__Overlay"
       className="ReactModal__Content"
    >
      <div className="modal-container">
        <button className="close-button" onClick={closeModal}>
          <span>X</span>
        </button>
        <div>
          {isYouTubeVideo ? (
        <iframe
          // width="560"
          // height="315"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1`}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          title="YouTube Video"
          frameBorder="0"
          allowFullScreen
          autoPlay
          className="youtube-video"
        ></iframe>
         ) : (
            <video
              className="youtube-video"
              controls
              autoPlay
            >
              <source src={videoUrl + videoId} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default VideoModal;
